import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ROUTE_STATUS_FAKESHIPPING_RESET = 'PUT_ROUTE_STATUS_FAKESHIPPING_RESET';
export const PUT_ROUTE_STATUS_FAKESHIPPING_LOADING = 'PUT_ROUTE_STATUS_FAKESHIPPING_LOADING';
export const PUT_ROUTE_STATUS_FAKESHIPPING_SUCCESS = 'PUT_ROUTE_STATUS_FAKESHIPPING_SUCCESS';
export const PUT_ROUTE_STATUS_FAKESHIPPING_REJECT = 'PUT_ROUTE_STATUS_FAKESHIPPING_REJECT';

//* ACTIONS ------------------------------------------------
export const putRouteStatusFakeShippingReset = () => ({ type: PUT_ROUTE_STATUS_FAKESHIPPING_RESET });
export const putRouteStatusFakeShippingLoading = () => ({ type: PUT_ROUTE_STATUS_FAKESHIPPING_LOADING });
export const putRouteStatusFakeShippingSuccess = (payload) => ({ type: PUT_ROUTE_STATUS_FAKESHIPPING_SUCCESS, payload });
export const putRouteStatusFakeShippingReject = (payload) => ({ type: PUT_ROUTE_STATUS_FAKESHIPPING_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putRouteStatusFakeShippingRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        params: { IdRoute: data.idRoute },
    }, getState);
    return request(`/Route/web/UpdateRouteChangestatusFakeShipping`, options);
};

